<template lang="pug">
.checkbox
  input(
    :id="id"
    :value="value"
    @input="$emit('input', $event)"
    @click="$emit('input', $event)"
    @change="$emit('input', $event)"
    type="checkbox"
  )
  label(
    v-if="label"
    :for="id"
  ) {{ label }}
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: String,
    id: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
    align-items: center;
    margin-bottom: 14px;
    &:last-child {
      margin-bottom: 0;
    }
    label{
      color: #000;
      font-weight: 700;
      font-size: 14px;
      margin-left: 4px;
      letter-spacing: 0.2px;
      text-transform: capitalize;
    }
    input{
      margin: 0;
      position: relative;
      -webkit-appearance: none;
      outline: none;
      width: 24px;
      min-width: 24px;
      height: 24px;
      background-color: #fff;
      cursor: pointer;

      &:after{
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 18px;
        height: 18px;
      }

      &:checked:after{
        background-color: $primary-color;
        border-radius: 2px;
      }
    }
}
</style>